import { Component, OnInit, OnDestroy } from '@angular/core';
import { ApplicationData } from 'src/app/data/application.data';
import { TranslateService } from '@ngx-translate/core';
import { ModalService } from 'src/app/services/modal.service';
import { UserService } from 'src/app/services/user.service';
import { UserData } from 'src/app/data/user.data';

@Component({
  selector: 'save-panel',
  templateUrl: './save-panel.component.html',
  host: {
    class: 'save-panel'
  }
})
export class SavePanelComponent implements OnInit, OnDestroy {

  public noFolderLabel:string;
  public currentFolder:string;
  public newFolderName:string;
  public projectNameError:boolean;

  private remoteProjectName:string;
  private remoteProjectFolder:string;

  /**
	 * Project Name
	 */
  public get projectName(): string {
    return this.applicationData.userProjectName == 'cfg_savePanel_myproject' ? this.translate.instant('cfg_savePanel_myproject') : this.applicationData.userProjectName;
  }
  public set projectName(value: string) {
    this.applicationData.userProjectName = value;
  }


  /**
	 * Constructor
	 */
  constructor(
    public userData: UserData,
    private applicationData: ApplicationData,
    private translate:TranslateService,
    private modalService:ModalService,
    private userService:UserService
  ) {
    this.noFolderLabel = this.translate.instant('cfg_noDirectory');
  }

	/**
	 * On init
	 */
  ngOnInit() {
    if(this.currentFolder == ''){
      this.setFolder(this.noFolderLabel);
    } else {
      this.currentFolder = this.applicationData.userProjectFolder;
      if(this.applicationData.userProjectId > 0){
        this.remoteProjectName = this.applicationData.userProjectName;
        this.remoteProjectFolder = this.applicationData.userProjectFolder;
      }
    }
  }

  /**
	 * set folder
	 */
  public setFolder(folder:string) {
    this.applicationData.userProjectFolder = folder;
    this.currentFolder = folder;
  }

  /**
	 * Create folder
	 */
  public createFolder() {
    this.modalService.open('modal-create-directory', { });
  }

  /**
	 * Register folder
	 */
  public registerFolder(folder:string) {
    if(this.userData.folders.indexOf(folder) > -1){
      this.setFolder(folder);
      return;
    }
    this.userService.addFolder(folder).then(
      (result: any) => {
        this.setFolder(folder);
        this.modalService.cancel('modal-create-directory');
      },
      (error: any) => {
        console.log(error);
      },
    ).catch((e: Error) => { console.error(e);  });

  }

  /**
	 * Save project
	 */
  public requestSaveProject() {

    // console.log(this.applicationData.configuration.getData());

    this.projectNameError = (this.projectName.trim() == "");
    if(this.projectNameError) return;

    if(this.userData.id > 0){
      if(this.applicationData.userProjectId > 0){
        console.log(this.remoteProjectName, this.projectName, (this.remoteProjectName == this.projectName), " //// ", this.remoteProjectFolder, this.currentFolder, (this.remoteProjectFolder == this.currentFolder))
        if((this.remoteProjectName == this.projectName) && (this.remoteProjectFolder == this.currentFolder)){
          // On ecrase
          this.modalService.open('modal-project-override', {});
        } else {
          this.saveProject();
        }
      } else {
        this.saveProject();
      }
    } else {
      this.userService.invokeLogin().then(()=>{
        if(this.applicationData.userProjectId > 0){
          if((this.remoteProjectName == this.projectName) && (this.remoteProjectFolder == this.currentFolder)){
            // On ecrase
            this.modalService.open('modal-project-override', {});
          } else {
            this.saveProject();
          }
        } else {
          this.saveProject();
        }
      },(error)=>{
        // Do nothing
      });
    }
  }

  public saveProject() {
    this.modalService.cancel('modal-project-override');
    this.userService.saveProject(
      this.applicationData.userProjectId,
      this.projectName,
      this.applicationData.userProjectFolder,
      this.applicationData.configuration.designFamilyId,
      this.applicationData.configuration.sheetId,
      this.applicationData.configuration.productFamilyId,
      this.applicationData.configuration.getData()
    ).then((project:any)=>{

      this.applicationData.userProjectId = project.id;
      this.applicationData.userProjectName = project.name;
      this.applicationData.userProjectFolder = project.folder;

      this.remoteProjectName = this.applicationData.userProjectName;
      this.remoteProjectFolder = this.applicationData.userProjectFolder;

      this.modalService.open('modal-save-message', {
        text : 'cfg_savePanel_confirmation'
      });
    }, (error)=>{
      console.log(error);
      this.modalService.open('modal-save-message', {
        text : 'cfg_savePanel_saveError'
      });
    });
  }

	/**
	* On destroy
	*/
  ngOnDestroy() {

  }
}
